<template>
  <b-card class="text-center">

    <!-- apex chart -->
    <vue-apex-charts
      type="radialBar"
      height="240"
      :options="goalOverviewRadialBar"
      :series="series"
    />

    <div class="truncate">
      <h6>{{ statisticText }}</h6>
      <span class="small">{{ statisticTitle }}</span>
    </div>
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'

const $strokeColor = '#ebe9f1'
const $textHeadingColor = '#5e5873'
const $goalStrokeColor2 = '#51e5a8'

export default {
  components: {
    BCard,
    VueApexCharts,
  },
  props: {
    icon: {
      type: String,
      required: true,
    },
    statistic: {
      type: [Number, String],
      required: true,
    },
    statisticValue: {
      type: [Number, String],
      required: true,
    },
    statisticTitle: {
      type: String,
      default: '',
    },
    statisticText: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'primary',
    },
  },
  data() {
    return {
      series: [this.statisticValue],
      goalOverviewRadialBar: {
        chart: {
          type: 'radialBar',
          sparkline: {
            enabled: true,
          },
          dropShadow: {
            enabled: false,
            blur: 3,
            left: 1,
            top: 1,
            opacity: 0.1,
          },
        },
        colors: [$goalStrokeColor2],
        plotOptions: {
          radialBar: {
            offsetY: -10,
            startAngle: -150,
            endAngle: 150,
            hollow: {
              size: '70%',
            },
            track: {
              background: $strokeColor,
              strokeWidth: '100%',
            },
            dataLabels: {
              name: {
                show: false,
              },
              value: {
                show: true,
                formatter: this.myFormatter,
                color: $textHeadingColor,
                fontSize: '2.4rem',
                fontWeight: '600',
              },
            },
          },
        },
        fill: {
          type: 'solid',
          colors: [$themeColors[this.findColor()]],
          // gradient: {
          //   shade: 'dark',
          //   type: 'horizontal',
          //   shadeIntensity: 0.5,
          //   gradientToColors: [$themeColors[this.color]],
          //   inverseColors: true,
          //   opacityFrom: 1,
          //   opacityTo: 1,
          //   stops: [0, 100],
          // },
        },
        stroke: {
          lineCap: 'round',
        },
        grid: {
          padding: {
            bottom: 30,
          },
        },
      },
    }
  },
  methods: {
    myFormatter() {
      return this.statistic
    },
    findColor() {
      if (this.color === 'dynamic') {
        if (parseFloat(this.statisticValue) < 26) {
          return 'danger'
        }
        if (parseFloat(this.statisticValue) < 51) {
          return 'warning'
        }
        if (parseFloat(this.statisticValue) < 76) {
          return 'info'
        }

        return 'success'
      }
      return this.color
    },
  },
}
</script>
